import { useState } from 'react'
import OverlayWrapper from '../../overlay/presentational/OverlayWrapper'
import ItemPerfomancesButtonGroup from '../../forms/fields/ItemPerfomancesButtonGroup'
import ItemPerfomancesCheckboxGroup from '../../forms/fields/ItemPerformancesCheckboxGroup'

const ListItemMovieNewspaperEditButton = ({itemData, onUpdate, cinemaTechnicalAttributes, cinemaMovieExtension}) => {
    let extensionsArray = cinemaMovieExtension && cinemaMovieExtension.technologyAttributes ? cinemaMovieExtension.technologyAttributes : []

    
    _.keys(cinemaTechnicalAttributes).map(attributeId => {
        const attributeMovies = cinemaTechnicalAttributes[attributeId].movies
        
        attributeMovies.map(attributeMovieId => {
            if(attributeMovieId === itemData.movieId) {
                if(!_.find(extensionsArray, extension => {
                    return extension.id === attributeId
                })) {
                    extensionsArray.push({
                        value: attributeId,
                        name: cinemaTechnicalAttributes[attributeId].name
                    })
                }
            }
        })
    })
    
    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <div className="item-edit">
                <div className='edit-icon-wrapper' onClick={() => {setIsOpen(true)}}>
                    <div className='edit-icon button button-edit'>
                        <span className="screen-reader-text">bearbeiten</span>
                    </div>
                </div>
            </div>
            {isOpen && <OverlayWrapper>
                <div className="item-edit-wrapper left-sections">
                    <div className="item-edit-inner">
                        <div className='close-icon-wrapper' onClick={() => {setIsOpen(false)}}>
                            <div className='close button-icon'>
                                <span className="screen-reader-text">schließen</span>
                            </div>
                        </div>
                        <ItemPerfomancesButtonGroup
                            dataKey='style'
                            transIdDescription="print_flyer_movie_style"
                            itemData={itemData}
                            onUpdate={onUpdate}
                            buttonsConfig={[
                                {
                                    "value":"default",
                                    "transId": "selection_style_classic"
                                }, 
                                {
                                    "value":"highlight",
                                    "transId": "section_types_highlight"
                                }
                            ]}
                        />
                      
                        <ItemPerfomancesCheckboxGroup
                            dataKey='attributes'
                            transIdDescription="print_flyer_movie_filter_attributes"
                            itemData={itemData}
                            onUpdate={onUpdate}
                            buttonsConfig={extensionsArray}
                        
                        />
                    </div>
                </div>
            </OverlayWrapper>}
        </>

    )
}
export default ListItemMovieNewspaperEditButton